import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  ref: "modal",
  id: "sc-modal",
  tabindex: "-1",
  "aria-labelledby": "sc-modal-label",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "sc-modal-label"
  }, "可能存在以下问题"),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "close"
  })
], -1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "list-group list-group-flush" }
const _hoisted_7 = {
  key: 0,
  class: "list-group-item"
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 缺少[")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-info" }, "附件作品", -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("]，请添加。 ")
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-info",
    "data-bs-dismiss": "modal"
  }, "补充内容")
], -1)
const _hoisted_13 = { class: "sc-get-help" }
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col mt-3" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "basic-input01",
  class: "form-label"
}, "你认为“新时代衢州人文精神”的关键词是什么?(关键词为2字词组，如“自信”“开放”)", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", {
  id: "basic-input01-h",
  class: "form-text",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" 填写20字以内 ")
], -1)
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  for: "basic-input02",
  class: "form-label"
}, "建议说明（200字内，要求突出衢州特点、时代特征、未来所向。）", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  id: "basic-input02-h",
  class: "form-text",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" 填写200字以内 ")
], -1)
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  for: "basic-input03",
  class: "form-label"
}, "姓名", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", {
  id: "basic-input03-h",
  class: "form-text",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" 填写真实姓名 ")
], -1)
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", {
  for: "basic-input03",
  class: "form-label"
}, "电话", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", {
  id: "basic-input03-h",
  class: "form-text",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" 填写电话号码 ")
], -1)
const _hoisted_29 = { class: "mb-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", {
  for: "basic-input04",
  class: "form-label"
}, "所在地区", -1)
const _hoisted_31 = /*#__PURE__*/_createStaticVNode("<option value=\"1\">柯城区</option><option value=\"2\">衢江区</option><option value=\"3\">龙游县</option><option value=\"4\">江山市</option><option value=\"5\">常山县</option><option value=\"6\">开化县</option><option value=\"7\">智造新城</option><option value=\"8\">智慧新城</option>", 8)
const _hoisted_39 = [
  _hoisted_31
]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", {
  id: "basic-input04-h",
  class: "form-text",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode("选择所在地区 ")
], -1)
const _hoisted_41 = { class: "mb-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("label", {
  for: "basic-input05",
  class: "form-label"
}, "职业", -1)
const _hoisted_43 = /*#__PURE__*/_createStaticVNode("<option value=\"1\">国家机关、党群组织、事业单位、国企人员</option><option value=\"2\">专业技术人员</option><option value=\"3\">民营企业及个体工商户人员</option><option value=\"4\">港澳台及外资企业人员</option><option value=\"5\">农林牧渔水利生产人员</option><option value=\"6\">工人</option><option value=\"7\">学生</option><option value=\"8\">军人</option><option value=\"9\">离退休人员</option><option value=\"10\">自由职业者</option><option value=\"11\">其他</option>", 11)
const _hoisted_54 = [
  _hoisted_43
]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", {
  id: "basic-input05-h",
  class: "form-text",
  style: {"display":"none"}
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" 选择职业 ")
], -1)
const _hoisted_56 = {
  class: "mb-3",
  style: {"display":"none"}
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", {
  for: "basic-input06",
  class: "form-label"
}, "附件作品", -1)
const _hoisted_58 = { class: "input-group mb-3" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", {
  class: "input-group-text",
  for: "basic-input06"
}, "添加", -1)
const _hoisted_60 = { style: {"display":"flex"} }
const _hoisted_61 = { class: "filename" }
const _hoisted_62 = ["onClick"]
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", {
  id: "basic-input05-h",
  class: "form-text"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" 多个附件需要打包上传 ")
], -1)
const _hoisted_64 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-info"
}, "提交", -1)
const _hoisted_65 = {
  key: 0,
  class: "tip-modal"
}
const _hoisted_66 = { class: "tip" }
const _hoisted_67 = { class: "title" }
const _hoisted_68 = {
  key: 0,
  class: "tip-btn"
}
const _hoisted_69 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_usage_info = _resolveComponent("usage-info")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              (!_ctx.fileModel)
                ? (_openBlock(), _createElementBlock("li", _hoisted_7, _hoisted_11))
                : _createCommentVNode("", true)
            ])
          ]),
          _hoisted_12
        ])
      ])
    ], 512),
    _createVNode(_component_usage_info),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("form", {
              onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submitContent()), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("textarea", {
                  type: "text",
                  class: "form-control",
                  id: "basic-input01",
                  maxlength: "20",
                  "aria-describedby": "basic-input01-h",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.createModel.title) = $event)),
                  autocomplete: "off",
                  required: "",
                  rows: "2"
                }, null, 512), [
                  [_vModelText, _ctx.createModel.title]
                ]),
                _hoisted_19
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _withDirectives(_createElementVNode("textarea", {
                  type: "text",
                  class: "form-control",
                  id: "basic-input02",
                  "aria-describedby": "basic-input02-h",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.createModel.content) = $event)),
                  autocomplete: "off",
                  required: "",
                  rows: "6"
                }, null, 512), [
                  [_vModelText, _ctx.createModel.content]
                ]),
                _hoisted_22
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "basic-input03",
                  "aria-describedby": "basic-input03-h",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.createModel.name) = $event)),
                  autocomplete: "off",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.createModel.name]
                ]),
                _hoisted_25
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "form-control",
                  id: "basic-input03",
                  "aria-describedby": "basic-input03-h",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createModel.mobile) = $event)),
                  autocomplete: "off",
                  required: ""
                }, null, 512), [
                  [_vModelText, _ctx.createModel.mobile]
                ]),
                _hoisted_28
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _withDirectives(_createElementVNode("select", {
                  type: "tel",
                  class: "form-control",
                  id: "basic-input04",
                  "aria-describedby": "basic-input04-h",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.Extmodel.region) = $event)),
                  autocomplete: "off",
                  required: ""
                }, _hoisted_39, 512), [
                  [_vModelSelect, _ctx.Extmodel.region]
                ]),
                _hoisted_40
              ]),
              _createElementVNode("div", _hoisted_41, [
                _hoisted_42,
                _withDirectives(_createElementVNode("select", {
                  type: "text",
                  class: "form-control",
                  id: "basic-input05",
                  "aria-describedby": "basic-input05-h",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.createModel.school) = $event)),
                  autocomplete: "off",
                  required: ""
                }, _hoisted_54, 512), [
                  [_vModelSelect, _ctx.createModel.school]
                ]),
                _hoisted_55
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("div", _hoisted_58, [
                  _createElementVNode("input", {
                    type: "file",
                    class: "form-control",
                    id: "basic-input06",
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onFileChanged && _ctx.onFileChanged(...args)))
                  }, null, 32),
                  _hoisted_59
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileArr, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", { key: index }, [
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, _toDisplayString(item.name), 1),
                      _createElementVNode("div", {
                        class: "deletetext",
                        onClick: ($event: any) => (_ctx.deleteFile(index))
                      }, "删除", 8, _hoisted_62)
                    ])
                  ]))
                }), 128)),
                _hoisted_63
              ]),
              _hoisted_64
            ], 32),
            (_ctx.showOrHide)
              ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                  _createElementVNode("div", _hoisted_66, [
                    _createElementVNode("div", _hoisted_67, _toDisplayString(_ctx.title), 1),
                    (_ctx.hasBtn)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                          _createElementVNode("a", { href: _ctx.jumpUrl }, "确定", 8, _hoisted_69)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ], 64))
}